<template>
  <div class="enter-wrap">
    <a href="#/policy-inquiries/person" class="enter-item content-wrap" style="margin-right: 30px;">
      <img src="@/assets/images/person.png" alt="" />
      <p class="title">我是人才</p>
      <p class="text">个人能申报那些人才政策？</p>
    </a>
    <a href="#/policy-inquiries/unit" class="enter-item content-wrap">
      <img src="@/assets/images/unit.png" alt="" />
      <p class="title">我是单位</p>
      <p class="text">单位能申报那些人才政策？</p>
    </a>
  </div>
</template>

<script>
export default {
  name: 'EnterBtn',
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
